<template>
    <div class="settings-quick-links-page">
        <quick-link-manager :embedded="true" />
    </div>
</template>

<script>
import QuickLinkManager from './QuickLinkManager.vue';

export default {
    name: 'SettingsQuickLinks',
    components: {
        QuickLinkManager: QuickLinkManager
    }
};
</script>

<style scoped>
.settings-quick-links-page {
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/SettingsQuickLinks.vue